import { useEffect, useState } from 'react';
import type { FacturacionApi } from '../api/types';
import { Alerta, ErrorApi } from '../components/ui';
import type { FacturacionCrApi, PaisComercio } from '../cr/types';
import { ConfiguracionFacturacionCostaRica } from './ConfiguracionFacturacionCostaRica';
import { ConfiguracionFacturacionPanama } from './ConfiguracionFacturacionPanama';

/**
 * Punto de entrada único del portal: pregunta a la API el país del comercio (EMP_EMPRESA.PAI_ID)
 * y muestra la pantalla de Costa Rica o la de Panamá.
 */
export function FacturacionElectronica(p: { apiPanama: FacturacionApi; apiCostaRica: FacturacionCrApi; idEmpresa: number }) {
  const [pais, setPais] = useState<PaisComercio | null>(null);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    let vivo = true;
    setPais(null);
    setError(null);
    p.apiCostaRica.pais(p.idEmpresa).then((x) => vivo && setPais(x)).catch((e) => vivo && setError(e));
    return () => {
      vivo = false;
    };
  }, [p.apiCostaRica, p.idEmpresa]);

  if (error) return <main className="pagina"><ErrorApi error={error} /></main>;
  if (!pais) return <main className="pagina"><div className="cargando" aria-busy>Cargando…</div></main>;
  if (pais.pais === 'CR') return <ConfiguracionFacturacionCostaRica api={p.apiCostaRica} idEmpresa={p.idEmpresa} />;
  if (pais.pais === 'PA') return <ConfiguracionFacturacionPanama api={p.apiPanama} idEmpresa={p.idEmpresa} />;
  return (
    <main className="pagina">
      <Alerta tipo="aviso" titulo="Facturación electrónica no disponible">La facturación electrónica está disponible para comercios de Costa Rica y Panamá.</Alerta>
    </main>
  );
}
